/**
 * Theme Toggle Component
 * Växlar mellan dark och light mode
 */

import { useState, useEffect } from 'react';
import { useTheme } from 'next-themes';
import { moonIcon, sunIcon } from '@/assets/icons/icons';

export default function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted) {
      setIsDarkMode((resolvedTheme || theme) === 'dark');
    }
  }, [resolvedTheme, theme, mounted]);

  const toggleTheme = (mode: 'light' | 'dark') => {
    setTheme(mode);
  };

  if (!mounted) {
    return null; // Prevent hydration mismatch
  }

  return (
    <div className="flex items-center justify-center">
      <div
        className="relative flex items-center justify-center gap-1 bg-BgPrimaryLight rounded-full shadow-[inset_0px_0px_3px_0px_var(--bgPrimary)] transition-colors duration-300 px-3 py-2 cursor-pointer"
        role="tablist"
        aria-label="Theme Selection"
      >
        <div
          className={`absolute h-7 w-7 rounded-full bg-BgPrimaryLight transition-transform duration-300 ease-in-out ${
            !isDarkMode ? 'translate-x-4' : '-translate-x-4'
          }`}
          aria-hidden="true"
        />
        <button
          role="tab"
          aria-selected={isDarkMode}
          aria-label="Light theme"
          onClick={() => toggleTheme('dark')}
          className="relative z-10 flex items-center justify-center text-[20px] w-7 h-7 cursor-pointer rounded-full text-bgPrimary"
        >
          {moonIcon}
        </button>
        <button
          role="tab"
          aria-selected={!isDarkMode}
          aria-label="Dark theme"
          onClick={() => toggleTheme('light')}
          className="relative z-10 flex items-center justify-center text-[20px] w-7 h-7 cursor-pointer rounded-full text-textTertiary"
        >
          {sunIcon}
        </button>
      </div>
    </div>
  );
}

